//精简/热门/一级赛事/五大联赛
export function hotAndOneEvents(level, e) {//五大联赛是data-level5, 一级赛事是data-level
  if (level) {
    $(".footClass li").css({ 'display': 'none' });
    $(".footClass li[" + level + "='1']").css({ 'display': 'block' });
  }
  cancelbtn(e);
  eventsHideNums();
  if (typeof showImg === "function") {
    showImg();
  }
}

//隐藏赛事数量
export function eventsHideNums() {
  var hiddenNums = $(".footClass>ul>li:hidden").length
  $('.v-li-4-5 span').text(hiddenNums)
}

//完整按钮--------------------------------------------------------
export function returnChoose() {
  $(".f-content>li").css({ 'display': 'block' });
  $('.f-content>li[data-zhiding="weizhiding"]').css({ 'display': 'none' });//*置顶被克隆的会添加weizhiding值,用来判断显示时不显示被克隆元素;
  //  window.localStorage.removeItem("chooseItem");
  var str = window.location.href.split("/");
  var strEnd = str[str.length - 1] ? str[str.length - 1] : str[str.length - 2];
  var oDate = ""
  if (strEnd.indexOf("saicheng") != -1) {
    strEnd = "saicheng";
    oDate = getDate() ? getDate() : currentDay();
  }
  if (strEnd.indexOf("zuqiu") != -1) {
    window.localStorage.setItem(strEnd + oDate + "-saishiItem", "1");
    window.localStorage.setItem(strEnd + oDate + "-rangqiuItem", "1");
    window.localStorage.setItem(strEnd + oDate + "-daxiaoItem", "1");
    window.localStorage.setItem(strEnd + oDate + "-countryItem", "1");
    window.localStorage.removeItem(strEnd + oDate + "-item");
  }
  if (typeof showImg === "function") {
    showImg();
  }
}

export function showItem() {
  var str = window.location.href.split("/");
  var strEnd = str[str.length - 1] ? str[str.length - 1] : str[str.length - 2];
  var trNums = $(".footClass>ul>li");
  var item = []
  for (var i = 0; i < trNums.length; i++) {
    if ($(trNums[i]).css("display") == "block") {
      item.push($(trNums[i]).data("id"))
    }
  }
  var oDate = ""
  if (strEnd.indexOf("saicheng") != -1) {
    strEnd = "saicheng";
    oDate = getDate() ? getDate() : currentDay();
  }
  window.localStorage.setItem(strEnd + oDate + "-item", JSON.stringify(item));
}

export function getDate() {
  var oDate = window.location.search.replace("?", "").split("&")
  var obj = {}
  for (var i = 0; i < oDate.length; i++) {
    obj[oDate[i].split("=")[0]] = oDate[i].split("=")[1]
  }
  return obj["date"] ? obj["date"] : ""
}

export function currentDay() {
  var date = new Date();
  var year = date.getFullYear(); //获取完整的年份(4位,1970-????)
  var month = date.getMonth() + 1 >= 10 ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1)); //获取当前月份(0-11,0代表1月)
  var day = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate(); //获取当前日(1-31)
  return "" + year + month + day;
}

export function showImg() {//动态图片ing dont haved
  if ($(".ing").find('.f-content>li[style="display: block;"]').length > 0) {
    $(".ing>img").css({ 'display': 'block' })
    var len = $(".ing").find('.f-content>li[style="display: block;"]').length;
    $(".ing").find('.f-content>li.rows').removeClass("rows");
    for (var i = 1; i < len; i = i + 2) {
      $($(".ing").find('.f-content>li[style="display: block;"]')[i]).addClass("rows")
    }
  } else {
    $(".ing>img").css({ 'display': 'none' })
  }
  if ($(".dont").find('.f-content>li[style="display: block;"]').length > 0) {
    $(".dont>img").css({ 'display': 'block' })
    // $("footer").css({'display':'block'})
    $(".dibu").css({ 'display': 'block' })
    var len = $(".dont").find('.f-content>li[style="display: block;"]').length;
    $(".dont").find('.f-content>li.rows').removeClass("rows");
    for (var i = 1; i < len; i = i + 2) {
      $($(".dont").find('.f-content>li[style="display: block;"]')[i]).addClass("rows")
    }
  } else {
    $(".dont>img").css({ 'display': 'none' })
  }
  if ($(".haved").find('.f-content>li[style="display: block;"]').length > 0) {
    $(".haved>img").css({ 'display': 'block' })
    var len = $(".haved").find('.f-content>li[style="display: block;"]').length;
    $(".haved").find('.f-content>li.rows').removeClass("rows");
    for (var i = 1; i < len; i = i + 2) {
      $($(".haved").find('.f-content>li[style="display: block;"]')[i]).addClass("rows")
    }
  } else {
    $(".haved>img").css({ 'display': 'none' })
  }
}

export function compare(property) {
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value1 - value2;
  }
}
// 选择赛事----------------------------------------------------------
export function ding1(days, states) {
  const inSchedule = /saicheng/i.test(location.pathname)
  const inOver = /wanchang/i.test(location.pathname)
  function saishi(days, states) {
    $('.v-li-5 .d-middle ul').empty();
    $.ajax({
      url: '/api/new/football_pc_league',
      data: {
        day: days,
        state: states//1未开赛 8完场
      },
      success: function (res) {
        $('.v-li-5 .d-middle ul').html('');
        const hotMatches = { title: '热门赛事', list: res.data.hot }
        const otherMatches = res.data.list
        const tags = []
        if (hotMatches.title && hotMatches.list) {
          tags.push(`<li class="hot_leagues" data-el='hot'><div class='m-left'>${hotMatches.title}</div><div class='m-right'>`)
          hotMatches.list.forEach(item => {
            let gradeEvents = ({ 1: 'league', 2: 'trophy' })[item.type] || ''
            $('.footClass>ul>li[data-league_id=' + item.league_id + ']').attr('data-level', 1)
            tags.push(`<div class="single-checkbox"><input type="checkbox" id="hot_${item.league_id}" data-level="${item.level}" class="hot ${item.league_status == 1 ? 'eFive' : ''} ${gradeEvents}" name="saishiCheck" checked><label for="hot_${item.league_id}">&nbsp;<span class="s-name" data-eId="${item.league_id}">${item.gb_short}</span><span class="s-num">[${item.num}]</span></label></div>`)
          })
          tags.push(`</div></li>`)
        }

        Object.keys(otherMatches).forEach(title => {
          const list = otherMatches[title]
          tags.push(`<li class="leagues" data-el='${title}'><div class='m-left'>${title}</div><div class='m-right'>`)
          list.forEach(item => {
            let gradeEvents = ({ 1: 'league', 2: 'trophy' })[item.type] || ''
            tags.push(`<div class="single-checkbox"><input type="checkbox" id="league_${item.league_id}" data-level="${item.level}" class="${gradeEvents}" name="saishiCheck" ${inOver || inSchedule || item.level == 1 ? 'checked' : ''}><label for="league_${item.league_id}">&nbsp;<span class="s-name" data-eId="${item.league_id}">${item.gb_short}</span><span class="s-num">[${item.num}]</span></label></div>`)
          })
          tags.push(`</div></li>`)
        })

        $('.v-li-5 .d-middle ul').html(tags.join(''))
        if (inSchedule || inOver) {
          returnChoose()
        } else {
          hotAndOneEvents('data-level')
        }
      }
    })
  }
  saishi(days, states);

  function bianli_saishi() {
    //遍历赛事个数
    var nums = $(".leagues input:checkbox[name='saishiCheck']:checked").length;
    $(".v-li-5 .d-bottom .b-left span").html("[" + nums + "]");
  }

  $('.v-li-5').on('click', function () {//计算赛事数目
    bianli_saishi();
  });

  $('.v-li-5').on('click', '[name=saishiCheck]', function () {//计算赛事数目
    console.info('saishiCheck', this.id.replace(/\D/g, ''))
    $('.v-li-5 [id$=_' + this.id.replace(/\D/g, '') + ']').prop('checked', this.checked)
    // this.id
  });

  $('.v-li-5').on('click', '.sure-checked', function (e) {
    // console.info('sure-checked')
    //确定
    var ids = []
    $("input:checkbox[name='saishiCheck']:checked").each(function () {
      ids.push(this.id.replace(/\D/g, ''))
    })
    // console.info('ids', ids)
    // var checkboxText = [];
    // var checkboxStr = $("input:checkbox[name='saishiCheck']"); //获取选取的值
    // for (var i = 0, ilen = checkboxStr.length; i < ilen; i++) {
    //   if ($(checkboxStr[i]).prop('checked')) {
    //     checkboxText[checkboxText.length] = $(checkboxStr[i]).siblings("label").children(".s-name").attr("data-eId");
    //   }
    // }
    var str = window.location.href.split("/");
    var strEnd = str[str.length - 1] ? str[str.length - 1] : str[str.length - 2];
    var oDate = ""
    if (strEnd.indexOf("saicheng") != -1) {
      strEnd = "saicheng";
      oDate = getDate() ? getDate() : currentDay();
    }
    if (window.localStorage.getItem(strEnd + oDate + "-saishiItem")) {
      window.localStorage.removeItem(strEnd + oDate + "-saishiItem");
    }
    window.localStorage.setItem(strEnd + oDate + "-saishiItem", JSON.stringify(ids));

    // var getSaishiItem = JSON.parse(window.localStorage.getItem(strEnd + oDate + "-saishiItem"));

    // var li_saishi_id = $(".footClass li .list_one");

    $(".footClass li").css({ 'display': 'none' })
    ids.forEach(id => {
      $(".footClass li[data-league_id='" + id + "']").css({ display: 'block' })
    })


    // for (var _i13 = 0, _i13len = getSaishiItem.length; _i13 < _i13len; _i13++) {
    //   //赛事
    //   for (var j = 0, _jlen = li_saishi_id.length; j < _jlen; j++) {
    //     //列表
    //     if ($.trim($(li_saishi_id[j]).attr('data-eId')) == getSaishiItem[_i13]) {
    //       $(li_saishi_id[j]).parent().parent().css({ 'display': 'block' });
    //     }
    //   }
    // }
    // window.localStorage.removeItem(strEnd + oDate + '-countryItem');
    // window.localStorage.removeItem(strEnd + oDate + '-rangqiuItem');
    //国家全选
    $("input:checkbox[name='countryCheck']").prop("checked", true);
    //盘口全选
    $("input:checkbox[name='rangqiuCheck']").prop("checked", true);
    showItem();
    // console.info('v5')
    eventsHideNums();
    cancelbtn(e);

    $(".view .v-dinglan > li").removeClass("v-active v-clicked");
    $('.v-li-5').addClass("v-active v-clicked")

    if (typeof showImg === "function") {
      showImg();
    }
  });

  $('.v-li-5').on('click', '.all-checked', function () {
    //全选
    $("input:checkbox[name='saishiCheck']").prop("checked", true);
  });

  $('.v-li-5').on('click', '.reverse-checked', function () {
    //全不选
    $("input:checkbox[name='saishiCheck']").prop("checked", false);
    //    反选
    //    $("input:checkbox[name='saishiCheck']").each(function () {
    //      $(this).prop('checked', !$(this).prop('checked'));
    //    });
  });

  $('.v-li-5').on('click', '.five-events', function () {
    var str = window.location.href.split("/");
    var strEnd = str[str.length - 1] ? str[str.length - 1] : str[str.length - 2];
    var oDate = ""
    if (strEnd.indexOf("saicheng") != -1) {
      strEnd = "saicheng";
      oDate = getDate() ? getDate() : currentDay();
    }
    $("input:checkbox[name='saishiCheck']").prop("checked", false);
    //选五大联赛
    $("input.eFive:checkbox[name='saishiCheck']").prop("checked", true);
    //国家全选
    $("input:checkbox[name='countryCheck']").prop("checked", true);
    //盘口全选
    $("input:checkbox[name='rangqiuCheck']").prop("checked", true);
    window.localStorage.removeItem(strEnd + oDate + '-countryItem');
    window.localStorage.removeItem(strEnd + oDate + '-rangqiuItem');
    var checkboxText = [];
    var checkboxStr = $("input:checkbox[name='saishiCheck']"); //获取选取的值
    for (var i = 0, ilen = checkboxStr.length; i < ilen; i++) {
      if ($(checkboxStr[i]).prop('checked')) {
        checkboxText[checkboxText.length] = $(checkboxStr[i]).siblings("label").children(".s-name").attr("data-eId");
      }
    }
    if (window.localStorage.getItem(strEnd + oDate + "-saishiItem")) {
      window.localStorage.removeItem(strEnd + oDate + "saishiItem");
    }
    window.localStorage.setItem(strEnd + oDate + "-saishiItem", JSON.stringify(checkboxText));
    $(".view .v-dinglan > li").removeClass("v-active v-clicked");
    $('.v-li-5').addClass("v-active v-clicked")
    showItem()
  });

  $('.v-li-5').on('click', '.one-events', function () {
    var str = window.location.href.split("/");
    var strEnd = str[str.length - 1] ? str[str.length - 1] : str[str.length - 2];
    var oDate = ""
    if (strEnd.indexOf("saicheng") != -1) {
      strEnd = "saicheng";
      oDate = getDate() ? getDate() : currentDay();
    }
    $("input:checkbox[name='saishiCheck']").prop("checked", false);
    //选择一级赛事
    $("input:checkbox[data-level='1']").prop("checked", true);
    //国家全选
    $("input:checkbox[name='countryCheck']").prop("checked", true);
    //盘口全选
    $("input:checkbox[name='rangqiuCheck']").prop("checked", true);

    var ids = []
    $("input:checkbox[name='saishiCheck']:checked").each(function () {
      var id = this.id.replace(/\D/g, '')
      ids.push(id)
    })

    if (window.localStorage.getItem(strEnd + oDate + "-saishiItem")) {
      window.localStorage.removeItem(strEnd + oDate + "saishiItem");
    }
    window.localStorage.setItem(strEnd + oDate + "-saishiItem", JSON.stringify(ids));

    $(".view .v-dinglan > li").removeClass("v-active v-clicked");
    $('.v-li-5').addClass("v-active v-clicked")

    showItem()
  })
}

export function saishiLoading() {
  //页面加载
  var str = window.location.href.split("/");
  var strEnd = str[str.length - 1] ? str[str.length - 1] : str[str.length - 2];
  var oDate = ""
  if (strEnd.indexOf("saicheng") != -1) {
    strEnd = "saicheng";
    oDate = getDate() ? getDate() : currentDay();
  }
  if (window.localStorage.getItem(strEnd + oDate + "-saishiItem") && window.localStorage.getItem(strEnd + oDate + "-saishiItem") != "1") {
    var getSaishiItem = JSON.parse(window.localStorage.getItem(strEnd + oDate + "-saishiItem"));
    var li_saishi_check = $(".v-li-5 li .s-name")
    $("input:checkbox[name='saishiCheck']").prop("checked", false);
    for (var _i13 = 0, _i13len = getSaishiItem.length; _i13 < _i13len; _i13++) {
      //赛事
      for (var z = 0, _zlen = li_saishi_check.length; z < _zlen; z++) {
        //列表
        if ($.trim($(li_saishi_check[z]).attr('data-eId')) == getSaishiItem[_i13]) {
          $($(li_saishi_check[z]).parent().parent().children("input:checkbox[name='saishiCheck']")).prop("checked", true);
        }
      }
    }
  }
}



//选择国家----------------------------------------------------------
export function ding2() {
  function country(days) {
    $('.v-li-6 .d-middle ul').empty();
    $.ajax({
      url: "/api/football_country",
      data: {
        day: days,
      },
      success: function (res) {
        var re = res.data;
        // console.info('country', res.data)
        // const tags = []
        // Object.keys(res.data).forEach(title => {
        //   const items = res.data[title]
        //   tags.push(`<li data-el="${title}"><div class="m-left">${title}</div><div class="m-right">`)
        //   items.forEach(item => {
        //     tags.push(`<div class="single-checkbox"><input type="checkbox" id="c_${item.country_id}" name="countryCheck" checked><label for="c_${item.country_id}">&nbsp;<span class="s-name" data-cId="${item.country_id}">${item.country_name}</span></label></div></div></li>`)
        //   })
        //   tags.push('</div></li>')
        // })
        // $('.v-li-6 .d-middle ul').html(tags.join(''))

        var elArr = [];
        var namezh = '';
        var namezht = '';
        var nameen = '';
        var el = '';
        var cId = Number;
        for (var i = 0, ilen = re.length; i < ilen; i++) {
          namezh = re[i].country_name;
          namezht = re[i].country_name;
          nameen = re[i].country_name;
          el = re[i].sort;
          cId = re[i].country_id;

          if (elArr.indexOf(el) != -1) {//页面字母的li存在,给赛事(-1是无)
            $('.v-li-6 .d-middle ul li[data-el="' + el + '"] .m-right').append('<div class="single-checkbox"><input type="checkbox" id="' + namezh + '" name="countryCheck" checked><label for="' + namezh + '">&nbsp;<span class="s-name" data-cId="' + cId + '" data-lang="' + namezh + ',' + namezht + ',' + nameen + '">' + namezh + '</span></label></div>')
          } else {//页面字母的li不存在,先新建,再给赛事
            elArr[elArr.length] = el;
            $('.v-li-6 .d-middle ul').append('<li data-el="' + el + '"><div class="m-left">' + el + '</div><div class="m-right"><div class="single-checkbox"><input type="checkbox" id="' + namezh + '" name="countryCheck" checked><label for="' + namezh + '">&nbsp;<span class="s-name" data-cId="' + cId + '" data-lang="' + namezh + ',' + namezht + ',' + nameen + '">' + namezh + '</span></label></div></div></li>')
          }
        }
      }
    })

  }
  country()
  function bianli_country() {
    //遍历国家个数
    var nums = 0;
    var saishi_nums = $("input:checkbox[name='countryCheck']");
    for (var _i18 = 0, _i18len = saishi_nums.length; _i18 < _i18len; _i18++) {
      if ($(saishi_nums[_i18]).prop('checked')) {
        nums++;
      }
    }
    $(".v-li-6 .d-bottom .b-left span").html("[" + nums + "]");
  }
  $('.v-li-6').on('click', function () {
    //计算国家数目
    bianli_country();
  });

  $('.v-li-6').on('click', '.sure-checked', function (e) {
    //确定
    var checkboxText = [];
    var checkboxStr = $("input:checkbox[name='countryCheck']"); //获取选取的值
    for (var i = 0, ilen = checkboxStr.length; i < ilen; i++) {
      if ($(checkboxStr[i]).prop('checked')) {
        checkboxText.push($(checkboxStr[i]).siblings("label").children(".s-name").attr("data-cId"));
      }
    }
    var str = window.location.href.split("/");
    var strEnd = str[str.length - 1] ? str[str.length - 1] : str[str.length - 2];
    var oDate = ""
    if (strEnd.indexOf("saicheng") != -1) {
      strEnd = "saicheng";
      oDate = getDate() ? getDate() : currentDay();
    }
    if (window.localStorage.getItem(strEnd + oDate + "-countryItem")) {
      window.localStorage.removeItem(strEnd + oDate + "-countryItem");
    }
    window.localStorage.setItem(strEnd + oDate + "-countryItem", JSON.stringify(checkboxText));

    var getCountryItem = JSON.parse(window.localStorage.getItem(strEnd + oDate + "-countryItem"));

    var li_country_id = $(".footClass li .up");

    $(".footClass li").css({ 'display': 'none' })
    for (var _i19 = 0, _i19len = getCountryItem.length; _i19 < _i19len; _i19++) {
      //赛事
      for (var j = 0; j < li_country_id.length; j++) {
        //列表
        if ($(li_country_id[j]).attr("data-cId") == getCountryItem[_i19]) {
          $(li_country_id[j]).parent().css({ 'display': 'block' });
        }
      }
    }



    window.localStorage.removeItem(strEnd + oDate + '-saishiItem');
    window.localStorage.removeItem(strEnd + oDate + '-rangqiuItem');
    //赛事全选
    $("input:checkbox[name='saishiCheck']").prop("checked", true);
    //盘口全选
    $("input:checkbox[name='rangqiuCheck']").prop("checked", true);
    showItem();
    console.info('v6')
    eventsHideNums();
    cancelbtn(e);
    $(".view .v-dinglan > li").removeClass("v-active v-clicked");
    $('.v-li-6').addClass("v-active v-clicked")
    if (typeof showImg === "function") {
      showImg();
    }
  });

  $('.v-li-6').on('click', '.all-checked', function () {
    //全选
    $("input:checkbox[name='countryCheck']").prop("checked", true);
  });

  $('.v-li-6').on('click', '.reverse-checked', function () {
    //全不选
    $("input:checkbox[name='countryCheck']").prop("checked", false);
    //反选
    //    $("input:checkbox[name='countryCheck']").each(function () {
    //      $(this).prop('checked', !$(this).prop('checked'));
    //    });
  });
}

export function countryLoading() {
  //页面加载
  var str = window.location.href.split("/");
  var strEnd = str[str.length - 1] ? str[str.length - 1] : str[str.length - 2];
  var oDate = ""
  if (strEnd.indexOf("saicheng") != -1) {
    strEnd = "saicheng";
    oDate = getDate() ? getDate() : currentDay();
  }
  if (window.localStorage.getItem(strEnd + oDate + "-countryItem") && window.localStorage.getItem(strEnd + oDate + "-countryItem") != "1") {
    var getCountryItem = JSON.parse(window.localStorage.getItem(strEnd + oDate + "-countryItem"));

    // var li_country_id = $(".footClass li .up");

    //  $(".footClass li").css({'display':'none'})
    var li_country_check = $(".v-li-6 li .s-name")
    $("input:checkbox[name='countryCheck']").prop("checked", false);

    for (var _i20 = 0, _i20len = getCountryItem.length; _i20 < _i20len; _i20++) {
      //赛事
      for (var z = 0, _zlen = li_country_check.length; z < _zlen; z++) {
        //列表
        if ($.trim($(li_country_check[z]).attr('data-cid')) == getCountryItem[_i20]) {
          $($(li_country_check[z]).parent().parent().children("input:checkbox[name='countryCheck']")).prop("checked", true);
        }
      }
      //    for (var j = 0; j < li_country_id.length; j++) {
      //      //列表
      //      if ($(li_country_id[j]).attr("data-cId") == getCountryItem[_i20]) {
      //        $(li_country_id[j]).parent().css({'display':'block'});
      //      }
      //    }
    }
  }
}

//选择盘口----------------------------------------------------------
export function ding3(that) {
  function rangqiu() {
    //让球
    var rangqiu_arr = [];
    var rangqiu_obj = {}

    $(".footClass li .f-w10").each(function (index) {
      var $el = $('.rangqiu_key', this)
      var text = $el.length ? $el.text() : '未开盘'
      text = text || '未开盘'
      rangqiu_obj[text] = rangqiu_obj[text] || 0
      rangqiu_obj[text] += 1
      if (!rangqiu_arr.includes(text)) {
        rangqiu_arr.push(text)
      }
    })
    that.rangqiu = rangqiu_arr;
    setTimeout(() => {
      rangqiu_count(rangqiu_obj);
    }, 1000);
  }
  rangqiu();
  function rangqiu_count(wordCount) {
    //渲染让球个数
    var s_name = $(".v-li-7 .rangqiu").find(".s-name");
    for (var key in wordCount) {
      for (var _i24 = 0, _i24len = s_name.length; _i24 < _i24len; _i24++) {
        if ($(s_name[_i24]).html() === key) {
          $(s_name[_i24]).siblings(".s-num").html("[" + wordCount[key] + "]");
        }
      }
    }
  }

  $('.v-li-7').on("click", ".all-checked1", function () {
    //全选
    $("input:checkbox[name='rangqiuCheck']").prop("checked", true);
  });

  $('.v-li-7').on("click", ".reverse-checked1", function () {
    //全不选
    $("input:checkbox[name='rangqiuCheck']").prop("checked", false);
    //反选
    //    $("input:checkbox[name='rangqiuCheck']").each(function () {
    //      $(this).prop('checked', !$(this).prop('checked'));
    //    });
  });

  $('.v-li-7').on("click", ".sure-checked1", function (e) {
    //确定
    var checkboxText = [];
    var checkboxStr = $("input:checkbox[name='rangqiuCheck']"); //获取选取的值
    for (var i = 0, ilen = checkboxStr.length; i < ilen; i++) {
      if ($(checkboxStr[i]).prop('checked')) {
        checkboxText.push($(checkboxStr[i]).siblings("label").children(".s-name").html());
      }
    }
    var str = window.location.href.split("/");
    var strEnd = str[str.length - 1] ? str[str.length - 1] : str[str.length - 2];
    var oDate = "";
    if (strEnd.indexOf("saicheng") != -1) {
      strEnd = "saicheng";
      oDate = getDate() ? getDate() : currentDay();
    }
    if (window.localStorage.getItem(strEnd + oDate + "-rangqiuItem")) {
      window.localStorage.removeItem(strEnd + oDate + "-rangqiuItem");
    }
    window.localStorage.setItem(strEnd + oDate + "-rangqiuItem", JSON.stringify(checkboxText));

    var getRangqiuItem = JSON.parse(window.localStorage.getItem(strEnd + oDate + "-rangqiuItem"));

    $(".footClass li").css({ 'display': 'none' });

    $(".footClass li .f-w10").each(function () {
      var $el = $('.rangqiu_key', this)
      if ($el.length && $el.text()) {
        if (getRangqiuItem.includes($el.text())) {
          $(this).parents('li:first').css({ 'display': 'block' });
        }
      } else if (getRangqiuItem.includes('未开盘')) {
        $(this).parents('li:first').css({ 'display': 'block' });
      }
    })

    window.localStorage.removeItem(strEnd + oDate + '-saishiItem');
    window.localStorage.removeItem(strEnd + oDate + '-countryItem');
    //赛事全选
    $("input:checkbox[name='saishiCheck']").prop("checked", true);
    //国家全选
    $("input:checkbox[name='countryCheck']").prop("checked", true);
    showItem();
    cancelbtn(e);
    eventsHideNums();

    $(".view .v-dinglan > li").removeClass("v-active v-clicked");
    $('.v-li-7').addClass("v-active v-clicked")
  });
  function daxiao() {
    //大小
    var daxiao_key = [];
    var daxiaoStr = $(".footClass li .f-w10");
    for (var _i27 = 0, _i27len = daxiaoStr.length; _i27 < _i27len; _i27++) {
      if ($(daxiaoStr[_i27]).find(".daxiao_key").length > 0) {
        if ($(daxiaoStr[_i27]).find(".daxiao_key").html().length > 0) {
          daxiao_key[daxiao_key.length] = $(daxiaoStr[_i27]).find(".daxiao_key").html();
        } else {
          daxiao_key[daxiao_key.length] = "未开盘";
        }
      } else {
        //undefined
        daxiao_key[daxiao_key.length] = "未开盘";
      }
    }

    var wordCount = {};
    for (var _i28 = 0, _i28len = daxiao_key.length; _i28 < _i28len; _i28++) {
      //大小个数
      if (wordCount[daxiao_key[_i28]] == undefined) {
        wordCount[daxiao_key[_i28]] = 1;
      } else {
        wordCount[daxiao_key[_i28]] += 1;
      }
    }

    var distinct = {};
    for (var _i29 = 0, _i29len = daxiao_key.length; _i29 < _i29len; _i29++) {
      //数组去重
      if (distinct[daxiao_key[_i29]] == undefined) {
        distinct[daxiao_key[_i29]] = daxiao_key[_i29];
      }
    }
    // console.info('distinct', distinct)
    that.daxiao = distinct;

    setTimeout(() => {
      daxiao_count(wordCount);
    }, 1000);
  }
  daxiao();
  function daxiao_count(wordCount) {
    //渲染大小个数
    var s_name = $(".v-li-7 .daxiao").find(".s-name");
    for (var key in wordCount) {
      for (var _i30 = 0, _i30len = s_name.length; _i30 < _i30len; _i30++) {
        if ($(s_name[_i30]).html() == key) {
          $(s_name[_i30]).siblings(".s-num").html("[" + wordCount[key] + "]");
        }
      }
    }
  }

  $('.v-li-7').on("click", ".all-checked2", function () {
    //全选
    $("input:checkbox[name='daxiaoCheck']").prop("checked", true);
  });

  $('.v-li-7').on("click", ".reverse-checked2", function () {
    //全不选
    $("input:checkbox[name='daxiaoCheck']").prop("checked", false);
    //反选
    //  $("input:checkbox[name='daxiaoCheck']").each(function () {
    //      $(this).prop('checked', !$(this).prop('checked'));
    //  });
  });

  $('.v-li-7').on("click", ".sure-checked2", function (e) {
    //确定
    var checkboxText = [];
    var checkboxStr = $("input:checkbox[name='daxiaoCheck']"); //获取选取的值
    for (var i = 0, ilen = checkboxStr.length; i < ilen; i++) {
      if ($(checkboxStr[i]).prop('checked')) {
        checkboxText.push($(checkboxStr[i]).siblings("label").children(".s-name").html());
      }
    }
    var str = window.location.href.split("/");
    var strEnd = str[str.length - 1] ? str[str.length - 1] : str[str.length - 2];
    var oDate = "";
    if (strEnd.indexOf("saicheng") != -1) {
      strEnd = "saicheng";
      oDate = getDate() ? getDate() : currentDay();
    }
    if (window.localStorage.getItem(strEnd + oDate + "-daxiaoItem")) {
      window.localStorage.removeItem(strEnd + oDate + "-daxiaoItem");
    }
    window.localStorage.setItem(strEnd + oDate + "-daxiaoItem", JSON.stringify(checkboxText));

    var getDaxiaoItem = JSON.parse(window.localStorage.getItem(strEnd + oDate + "-daxiaoItem"));

    $(".footClass li").css({ 'display': 'none' })

    $(".footClass li .f-w10").each(function () {
      var $el = $('.daxiao_key', this)
      if ($el.length) {
        if (getDaxiaoItem.includes($el.text())) {
          $(this).parents('li:first').css({ 'display': 'block' });
        }
      } else if (getDaxiaoItem.includes('未开盘')) {
        $(this).parents('li:first').css({ 'display': 'block' });
      }
    })

    showItem();
    cancelbtn(e);
    console.info('v7')
    eventsHideNums();

    $(".view .v-dinglan > li").removeClass("v-active v-clicked");
    $('.v-li-7').addClass("v-active v-clicked")
    if (typeof showImg === "function") {
      showImg();
    }
  });
}

export function rangqiuLoading() {
  //页面加载
  var str = window.location.href.split("/");
  var strEnd = str[str.length - 1] ? str[str.length - 1] : str[str.length - 2];
  var oDate = "";
  if (strEnd.indexOf("saicheng") != -1) {
    strEnd = "saicheng";
    oDate = getDate() ? getDate() : currentDay();
  }
  if (window.localStorage.getItem(strEnd + oDate + "-rangqiuItem") && window.localStorage.getItem(strEnd + oDate + "-rangqiuItem") != "1") {
    var getRangqiuItem = JSON.parse(window.localStorage.getItem(strEnd + oDate + "-rangqiuItem"));

    var li_rangqiu_name = $(".footClass li .f-w10 .rangqiu_key");
    var kong = $(".footClass li .f-w10");

    //  $(".footClass li").css({'display':'none'})

    console.info('getRangqiuItem', getRangqiuItem)

    for (var _i26 = 0, _i26len = getRangqiuItem.length; _i26 < _i26len; _i26++) {
      //赛事
      var flag = true;
      if (getRangqiuItem[_i26] == "未开盘" && flag) {
        for (var j = 0, jlen = kong.length; j < jlen; j++) {
          if ($(kong[j]).find(".rangqiu_key").length == 0) {
            $(kong[j]).parent().parent().css({ 'display': 'block' });
            var _flag = false;
          }
        }
      }
      //    for (var _j2 = 0,_j2len=li_rangqiu_name.length; _j2 < _j2len; _j2++) {
      //      //列表
      //      if ($(li_rangqiu_name[_j2]).html() == getRangqiuItem[_i26]) {
      //        $(li_rangqiu_name[_j2]).parent().parent().parent().parent().parent().css({'display':'block'});
      //      }
      //    }
    }
  }
}

export function daxiaoLoading() {
  //页面加载
  var str = window.location.href.split("/");
  var strEnd = str[str.length - 1] ? str[str.length - 1] : str[str.length - 2];
  var oDate = "";
  if (strEnd.indexOf("saicheng") != -1) {
    strEnd = "saicheng";
    oDate = getDate() ? getDate() : currentDay();
  }
  if (window.localStorage.getItem(strEnd + oDate + "-daxiaoItem") && window.localStorage.getItem(strEnd + oDate + "-daxiaoItem") != "1") {

    var getDaxiaoItem = JSON.parse(window.localStorage.getItem(strEnd + oDate + "-daxiaoItem"));

    var li_daxiao_name = $(".footClass li .f-w10 .daxiao_key");
    var kong = $(".footClass li .f-w10");

    //  $(".footClass li").css({'display':'none'})

    for (var _i32 = 0, _i32len = getDaxiaoItem.length; _i32 < _i32len; _i32++) {
      //赛事
      var flag = true;
      if (getDaxiaoItem[_i32] == "未开盘" && flag) {
        for (var j = 0, jlen = kong.length; j < jlen; j++) {
          if ($(kong[j]).find(".daxiao_key").length == 0) {
            $(kong[j]).parent().parent().css({ 'display': 'block' });
            flag = false;
          }
        }
      }
      //    for (var _j4 = 0,_j4len=li_daxiao_name.length; _j4 < _j4len; _j4++) {
      //      //列表
      //      if ($(li_daxiao_name[_j4]).html() == getDaxiaoItem[_i32]) {
      //        $(li_daxiao_name[_j4]).parent().parent().parent().parent().parent().css({'display':'block'});
      //      }
      //    }
    }
    if (typeof showImg === "function") {
      showImg();
    }
  }
}

//中英繁------------------------------------------------------------------
export function langChange(lang) {
  var saishiName = $('.f-content .lan-s');
  for (var x = 0, xlen = saishiName.length; x < xlen; x++) {
    $(saishiName[x]).find('span').html($(saishiName[x]).attr("data-lang").split(',')[lang])
  }
  var homeTeamName = $('.f-content .lan-h .teamName');
  var awayTeamName = $('.f-content .lan-a .teamName');
  var home = $('.f-content li');
  for (var y = 0, ylen = homeTeamName.length; y < ylen; y++) {
    $(homeTeamName[y]).children('.pointer').html($(homeTeamName[y]).attr("data-lang").split(',')[lang])
    $(awayTeamName[y]).children('.pointer').html($(awayTeamName[y]).attr("data-lang").split(',')[lang])
    if ($(home[y]).find('.god-anchor .g-middle .g-header>div').length > 0) {
      //  	$($(home[y]).find('.god-anchor .g-middle .g-header div')[0]).html($(homeTeamName[y]).attr("data-lang").split(',')[lang])
      //  	$($(home[y]).find('.god-anchor .g-middle .g-header div')[1]).html($(awayTeamName[y]).attr("data-lang").split(',')[lang])
    }
    $($(home[y]).find('.god-anchor .g-middle .g-header>div')[0]).html($(homeTeamName[y]).attr("data-lang").split(',')[lang])
    $($(home[y]).find('.god-anchor .g-middle .g-header>div')[1]).html($(awayTeamName[y]).attr("data-lang").split(',')[lang])
  }
  //for(var z = 0,zlen=awayTeamName.length; z< zlen; z++){
  //}

  var eventName = $('.v-dinglan .v-li-5 .d-middle .s-name');
  for (var xx = 0, xxlen = eventName.length; xx < xxlen; xx++) {
    $(eventName[xx]).html($(eventName[xx]).attr("data-lang").split(',')[lang])
  }
  var countryName = $('.v-dinglan .v-li-6 .d-middle .s-name');
  for (var xx = 0, xxlen = countryName.length; xx < xxlen; xx++) {
    $(countryName[xx]).html($(countryName[xx]).attr("data-lang").split(',')[lang])
  }

  localStorage.setItem('langChange', lang)
}

export function getLangChange() {//加载
  if (localStorage.getItem('langChange') && localStorage.getItem('langChange') != '2') {
    langChange(localStorage.getItem('langChange'))
  }
  switch (localStorage.getItem('langChange')) {
    case '0':
      $(".v-li-10 .one-first").addClass("m-active").siblings().removeClass("m-active");
      break;
    case '1':
      $(".v-li-10 .one-second").addClass("m-active").siblings().removeClass("m-active");
      break;
    //  case '2':
    //      $(".set-box .one-third").addClass("m-active").siblings().removeClass("m-active");
    //    break;
  }
}

//顶栏按钮----------------------------------------------------------------
export function dinglanClick() {
  //五大联赛
  $('.v-li-5').on('click', '.five-events', function (e) {
    hotAndOneEvents("data-level5", e);
  })
  //一级赛事
  $('.v-li-5').on('click', '.one-events', function (e) {
    hotAndOneEvents("data-level", e)
  })
  $(".view .v-left>li").on("click", function () {//  弹出下拉框
    $(".view .v-left>li").children(".down.show").removeClass("show");
    $(this).children(".down").addClass("show");
  });
  $(".cancel-checked").on("click", function (e) {//  取消按钮
    cancelbtn(e);
  });
  $(".down>.guanbi").on("click", function (e) {//  ×号关闭
    e.stopPropagation();
    $(".view ul li").children(".down.show").removeClass("show");
  });

  $(".view .v-dinglan").on('click', '.v-li-4', function () {// 完整和热门按钮点击变色

    //全选
    $("input:checkbox[name='saishiCheck']").prop("checked", true);
    $("input:checkbox[name='countryCheck']").prop("checked", true);
    $("input:checkbox[name='rangqiuCheck']").prop("checked", true);

    $(".view .v-dinglan > li").removeClass("v-active v-clicked");
    $('.v-li-4').addClass("v-active v-clicked")
    eventsHideNums()
  })
  $(".v-li-3").on('click', function () {// 完整和热门按钮点击变色
    $('.one-events').trigger('click')
    $(".view .v-dinglan > li").removeClass("v-active v-clicked");
    $('.v-li-3').addClass("v-active v-clicked")
  })

  $(".view .v-dinglan>li").hover(function () {//  顶栏按钮移入变色
    $(this).addClass("v-active");
  }, function () {
    if (!$(this).hasClass("v-clicked")) {
      $(this).removeClass("v-active");
    }
  });
  $(".view .v-dinglan>a>li").hover(function () {//  顶栏按钮移入变色(跳转标签包裹)
    $(this).addClass("v-active");
  }, function () {
    if (!$(this).hasClass("v-clicked")) {
      $(this).removeClass("v-active");
    }
  });
  $(".b-right ul>li").hover(function () {//  弹出框内按钮移入变色
    $(this).css({
      backgroundColor: "#e24949",
      color: "#fff"
    });
  }, function () {
    $(this).css({
      backgroundColor: "",
      color: "#e24949"
    })
  });
  $(".guanbi").hover(function () {//  ×号移入变色
    $(this).css({
      color: "#e24949"
    });
  }, function () {
    $(this).css({
      color: "grey"
    });
  });
  $(".v-li-7 .d-up-tab .tab").each(function (index) {//  选择盘口的tab栏切换逻辑
    $(this).on("click", function () {
      $(".v-li-7 .d-up-tab .tab").removeClass("tabCurrent");
      $(this).addClass("tabCurrent");
      $(".v-li-7 .d-middle .tab-content").removeClass("tabShow");
      $(".v-li-7 .d-middle .tab-content").eq(index).addClass("tabShow");
      if ($(this).hasClass('tab-left')) {
        $(".v-li-7 .all-checked").removeClass("all-checked2");
        $(".v-li-7 .reverse-checked").removeClass("reverse-checked2");
        $(".v-li-7 .sure-checked").removeClass("sure-checked2");
        $(".v-li-7 .all-checked").addClass("all-checked1");
        $(".v-li-7 .reverse-checked").addClass("reverse-checked1");
        $(".v-li-7 .sure-checked").addClass("sure-checked1");
      } else {
        $(".v-li-7 .all-checked").removeClass("all-checked1");
        $(".v-li-7 .reverse-checked").removeClass("reverse-checked1");
        $(".v-li-7 .sure-checked").removeClass("sure-checked1");
        $(".v-li-7 .all-checked").addClass("all-checked2");
        $(".v-li-7 .reverse-checked").addClass("reverse-checked2");
        $(".v-li-7 .sure-checked").addClass("sure-checked2");
      }
    });
  });
  $(".view-set").on("click", function (e) {//  设置按钮-遮罩层-出现
    e.stopPropagation();
    //      event = event || window.event
    //		    if (event.stopPropagation) {
    //		      //IE浏览器
    //		      event.stopPropagation();
    //		    } else {
    //		      //非IE浏览器
    //		      event.cancelBubble = true;
    //		    }
    $(".set-mask").css('display', 'block');
  });
  $(".set-box>.guanbi").on("click", function (e) {//  设置按钮-遮罩层-关闭
    e.stopPropagation();
    //      event = event || window.event
    //		    if (event.stopPropagation) {
    //		      //IE浏览器
    //		      event.stopPropagation();
    //		    } else {
    //		      //非IE浏览器
    //		      event.cancelBubble = true;
    //		    }
    $(".set-mask").css('display', 'none');
  });
}

export function cancelbtn(event) {//  取消事件(防冒泡)
  event = event || window.event
  if (event.stopPropagation) {
    //IE浏览器
    event.stopPropagation();
  } else {
    //非IE浏览器
    event.cancelBubble = true;
  }
  //  e.stopPropagation();
  $(".view ul li").children(".down.show").removeClass("show");
};

// //赛事即时统计(问路神针)============================================
export function football_statistics_ajax(ids, thats) {

  $.ajax({
    // url: COMMOND.NEW_BASE_URL + "getfootball_statistics",
    url: COMMOND.NEW_BASE_URL + "football_technical",
    data: {
      id: ids
    },
    success: function success(res) {
      // 1:入球，2:红牌，3:黄牌，7:点球，8:乌龙，9:两黄变红，11:换人，13:射失点球
      if (res.code == 200) {
        const { event, technic } = res.data
        $(thats).find(".god-anchor .g-middle tbody").html("");
        // $(thats).find(".god-anchor .g-bottom tbody").html("");
        const eventTags = []
        event.forEach(item => {
          switch (item.kind) {
            case 1:
            case 2:
            case 3:
            case 7:
            case 8:
            case 9:
            case 11:
            case 13:
              if (item.is_home) {
                eventTags.push(`<tr><td class="g-m-middle"><span class="name r">${item.player}</span><span><img src="//static.fly2a.com/gqj/icon-text-${item.kind}.png" style="display: inline;"></span></td><td class="g-m-left">${item.time}'</td><td class="g-m-right"></td></tr>`)
              } else {
                eventTags.push(`<tr><td class="g-m-middle"></td><td class="g-m-left">${item.time}'</td><td class="g-m-right"><span><img src="//static.fly2a.com/gqj/icon-text-${item.kind}.png" style="display: inline;"></span><span class="name l">${item.player}</span></td></tr>`)
              }
              break

          }
        })
        $(thats).find(".god-anchor .g-middle tbody").html(eventTags.join(''))
        makeTechnicStatistics(technic)
      }

    }
  });

  function makeTechnicStatistics(res) {
    $(thats).find(".god-anchor .g-bottom tbody").html("");
    var sz_home = res.home_shoot_positive ? res.home_shoot_positive : 0;
    var sz_away = res.away_shoot_positive ? res.away_shoot_positive : 0;
    var sz_home1 = 0;
    var sz_away1 = 0;
    var sm_home = res.home_shoot ? res.home_shoot : 0;
    var sm_away = res.away_shoot ? res.away_shoot : 0;
    var sm_home1 = 0;
    var sm_away1 = 0;
    var red_home = res.home_red ? res.home_red : 0;
    var red_away = res.away_red ? res.away_red : 0;
    var red_home1 = 0;
    var red_away1 = 0;
    var yel_home = res.home_yellow ? res.home_yellow : 0;
    var yel_away = res.away_yellow ? res.away_yellow : 0;
    var yel_home1 = 0;
    var yel_away1 = 0;
    var st_home = res.home_ball_control ? res.home_ball_control : 0;
    var st_away = res.away_ball_control ? res.away_ball_control : 0;
    if (yel_home != 0 || yel_away != 0 || red_home != 0 || red_away != 0 || sz_home != 0 || sz_away != 0 || sm_home != 0 || sm_away != 0 || st_home != 0 || st_away != 0) {
      if (yel_home != 0 || yel_away != 0) {
        yel_home1 = Number(((yel_home / (yel_home + yel_away)) * 100).toFixed(0))
        yel_away1 = Number(((yel_away / (yel_home + yel_away)) * 100).toFixed(0))
        var str1 = ' \n<div class=\"progress progress-l\">\n<span class=\"barControl\">\n<div class=\"barContro_space\">\n<span class=\"vader\" style=\"height: 6px; width:' + yel_home1 + '%\">\n</span>\n</div>\n</span>\n</div>'
        var str2 = '\n<div class=\"progress progress-r\">\n<span class=\"barControl\">\n<div class=\"barContro_space\">\n<span class=\"vader\" style=\"height: 6px; width:' + yel_away1 + '%\">\n</span>\n</div>\n</span>\n</div>'
        $(thats).find('.god-anchor .g-bottom tbody').prepend("<tr>\n<td class=\"g-b-left\">" + yel_home + "</td>\n<td class=\"g-b-middle\">" + str1 + "\n<div class=\"progress-t\">\u9ec4\u724c\n</div>" + str2 + "</td>\n<td class=\"g-b-right\">" + yel_away + "</td>\n</tr>\n");
      }
      if (red_home != 0 || red_away != 0) {
        red_home1 = Number(((red_home / (red_home + red_away)) * 100).toFixed(0))
        red_away1 = Number(((red_away / (red_home + red_away)) * 100).toFixed(0))
        var str1 = ' \n<div class=\"progress progress-l\">\n<span class=\"barControl\">\n<div class=\"barContro_space\">\n<span class=\"vader\" style=\"height: 6px; width:' + red_home1 + '%\">\n</span>\n</div>\n</span>\n</div>'
        var str2 = '\n<div class=\"progress progress-r\">\n<span class=\"barControl\">\n<div class=\"barContro_space\">\n<span class=\"vader\" style=\"height: 6px; width:' + red_away1 + '%\">\n</span>\n</div>\n</span>\n</div>'
        $(thats).find('.god-anchor .g-bottom tbody').prepend("<tr>\n<td class=\"g-b-left\">" + red_home + "</td>\n<td class=\"g-b-middle\">" + str1 + "\n<div class=\"progress-t\">\u7ea2\u724c\n</div>" + str2 + "</td>\n<td class=\"g-b-right\">" + red_away + "</td>\n</tr>\n");
      }
      if (sz_home != 0 || sz_away != 0) {
        sz_home1 = Number(((sz_home / (sz_home + sz_away)) * 100).toFixed(0))//射正
        sz_away1 = Number(((sz_away / (sz_home + sz_away)) * 100).toFixed(0))//射正
        var str1 = ' \n<div class=\"progress progress-l\">\n<span class=\"barControl\">\n<div class=\"barContro_space\">\n<span class=\"vader\" style=\"height: 6px; width:' + sz_home1 + '%\">\n</span>\n</div>\n</span>\n</div>'
        var str2 = '\n<div class=\"progress progress-r\">\n<span class=\"barControl\">\n<div class=\"barContro_space\">\n<span class=\"vader\" style=\"height: 6px; width:' + sz_away1 + '%\">\n</span>\n</div>\n</span>\n</div>'
        $(thats).find('.god-anchor .g-bottom tbody').prepend("\n<tr>\n<td class=\"g-b-left\">" + sz_home + "</td>\n<td class=\"g-b-middle\">" + str1 + "\n<div class=\"progress-t\">\u5C04\u6B63\n</div>" + str2 + "</td>\n<td class=\"g-b-right\">" + sz_away + "</td>\n</tr>\n");
      }
      if (sm_home != 0 || sm_away != 0) {
        sm_home1 = Number(((sm_home / (sm_home + sm_away)) * 100).toFixed(0))
        sm_away1 = Number(((sm_away / (sm_home + sm_away)) * 100).toFixed(0))
        var str1 = ' \n<div class=\"progress progress-l\">\n<span class=\"barControl\">\n<div class=\"barContro_space\">\n<span class=\"vader\" style=\"height: 6px; width:' + sm_home1 + '%\">\n</span>\n</div>\n</span>\n</div>'
        var str2 = '\n<div class=\"progress progress-r\">\n<span class=\"barControl\">\n<div class=\"barContro_space\">\n<span class=\"vader\" style=\"height: 6px; width:' + sm_away1 + '%\">\n</span>\n</div>\n</span>\n</div>'
        $(thats).find('.god-anchor .g-bottom tbody').prepend("\n<tr>\n<td class=\"g-b-left\">" + sm_home + "</td>\n<td class=\"g-b-middle\">" + str1 + "\n<div class=\"progress-t\">\u5C04\u95E8\n</div>\n" + str2 + "</td>\n<td class=\"g-b-right\">" + sm_away + "</td>\n</tr>\n");
      }
      if (st_home != 0 || st_away != 0) {
        var str1 = ' \n<div class=\"progress progress-l\">\n<span class=\"barControl\">\n<div class=\"barContro_space\">\n<span class=\"vader\" style=\"height: 6px; width:' + st_home + '%\">\n</span>\n</div>\n</span>\n</div>'
        var str2 = '\n<div class=\"progress progress-r\">\n<span class=\"barControl\">\n<div class=\"barContro_space\">\n<span class=\"vader\" style=\"height: 6px; width:' + st_away + '%\">\n</span>\n</div>\n</span>\n</div>'
        $(thats).find('.god-anchor .g-bottom tbody').append("<tr>\n<td class=\"g-b-left\">" + st_home + "%</td>\n<td class=\"g-b-middle\">" + str1 + "\n<div class=\"progress-t\">\u63a7\u7403\u7387\n</div>" + str2 + "</td>\n<td class=\"g-b-right\">" + st_away + "%</td>\n</tr>");
      }
    } else {
      $(thats).find('.god-anchor .g-bottom tbody').prepend('\n<tr>\n<td class=\"g-m-left\">\n</td>\n<td class=\"g-m-middle\" style=\"color:#807f7f;font-size:12px\">\u6682\u65e0\n</td>\n<td class=\"g-m-right\">\n</td>\n</tr>')
    }
  }
}


